import {Injectable} from '@angular/core';
import {LoanApplicationPipelineStage, LoanApplicationTransition} from '../../../../model/LoanApplicationTransition';
import {ActiveApplicationTile, LoanTile} from './tiles';
import {LoanApplication} from '../../../../model/loan-application.model';
import {Loan} from '../../../../model/loan.model';
import {DisplayableLoanStatus, LoanStatus, LoanStatusType} from '../../../../model/loan-status.model';
import {CommonUtil} from '../../../../utils/common.util';
import moment = require('moment');

@Injectable()
export class TileFactory {
    public createForActiveApplication(activeApplication: any): ActiveApplicationTile {
        return {
            application: activeApplication,
            status: 'Your loan application is in progress',
            action: 'Go back to Application',
            redirectRoute: `/borrow/application/${activeApplication.id}`,
            loanSuggestedTermAction: 'Loans with suggested terms',
            loanSuggestedTermRoute: `/borrow/dashboard/loan-suggested-term`,
            nonRetail: activeApplication.nonRetail
        };
    }


    public createForRejectedOrClosedApplication(loanApplication: LoanApplication, loan: Loan,
                                                transitions: LoanApplicationTransition[]): LoanTile {
        const [status, colorCode] = loan ? this.getDisplayStatusAndColorCode(loan) :  [DisplayableLoanStatus.Rejected, '#666666'];

        return  new LoanTile(loanApplication.shortId, loan ? loan.loan_reason : loanApplication.reason, loan ? loan.loan_amount : loanApplication.amount,
            this.getLoanRoi(loan), loan ? loan.loan_tenure : loanApplication.tenure, this.findLoanApplicationSubmissionDate(loanApplication.id, transitions), status, null, colorCode);
    }

    public createForYetToBeSanctionedLoanApplication(loanApplication: LoanApplication, transitions: LoanApplicationTransition[]): LoanTile {
        return  new LoanTile(loanApplication.shortId, loanApplication.reason, loanApplication.amount, null, loanApplication.tenure, this.findLoanApplicationSubmissionDate(loanApplication.id, transitions),
            DisplayableLoanStatus.InProgress, null, '#acacac');
    }

    public createForLoan(loan: Loan, transitions?: LoanApplicationTransition[], noRedirection?: boolean): LoanTile {
        const [status, colorCode, redirection] = this.getDisplayStatusAndColorCode(loan, noRedirection);
        const applicationDate = transitions ? this.findLoanApplicationSubmissionDate(loan.loanApplicationId, transitions) : null;
        return  new LoanTile(loan.generated_loan_id, loan.loan_reason, loan.loan_amount, this.getLoanRoi(loan), loan.loan_tenure, applicationDate, status, redirection, colorCode);
    }

    private findLoanApplicationSubmissionDate(loanApplicationId, transitions: LoanApplicationTransition[]): Date {
        const noneToVerificationTransition =  transitions.find(transition => transition.entityId === loanApplicationId && transition.toStage === LoanApplicationPipelineStage.Verification);
        return noneToVerificationTransition ? moment(noneToVerificationTransition.createdAt).toDate() : null;
    }

    private getDisplayStatusAndColorCode(loan: Loan, noRedirection?: boolean): [DisplayableLoanStatus, string, {link: string, label: string}? ] {
        if (loan.loan_sanction_status === LoanStatusType.Sanctioned) {
            return [DisplayableLoanStatus.InProgress, '#acacac', {link: `/borrow/dashboard/application/${loan.loanApplicationId}/offer`, label: 'Review Offer'}];
        } else if (LoanStatus.isAcceptedButYetToBeDisbursed(loan.loan_sanction_status)) {
            return [DisplayableLoanStatus.InProgress, '#4db53e', null];
        } else if (loan.loan_sanction_status === LoanStatusType.ClosedPrepayment) {
            return [DisplayableLoanStatus.PrepaidAndClosed, '#666666'];
        } else if (loan.loan_sanction_status === LoanStatusType.LoanMatured) {
            return [DisplayableLoanStatus.MaturedAndClosed, '#666666'];
        } else if (loan.loan_sanction_status === LoanStatusType.Closed) {
            return [DisplayableLoanStatus.Closed, '#666666'];
        } else if (loan.loan_sanction_status === LoanStatusType.ClosedSettlement) {
            return [DisplayableLoanStatus.SettledAndClosed, '#666666'];
        } else if (loan.loan_sanction_status === LoanStatusType.Rejected) {
            return [DisplayableLoanStatus.Rejected, '#666666'];
        } else {
            return [CommonUtil.isEmpty(loan.loanRestructuredOn) ? DisplayableLoanStatus.Active : DisplayableLoanStatus.RestructuredAndActive, '#4db53e',
                !noRedirection ? {link: `/borrow/dashboard/loan/${loan._id}`, label: 'View Loan'} : null];
        }
    }

    public getLoanRoi(loan: Loan) {
        if (loan) {
            return loan.effective_roi === undefined || loan.effective_roi === null ? loan.roi : loan.effective_roi;
        } else {
            return null;
        }
    }
}
